import FromToFilterComponent from '@/components/global/filters/FromToFilterComponent.jsx';
import { ReferenceArrayFilter } from '@/components/global/filters/filters.jsx';
import { SearchBar } from '@/components/global/list/searchBar.jsx';

export const BRAND_SEARCH_FIELDS = {
    name: true,
    'retailChain.name': true,
};

export const getBrandFilters = (isMobile, translate) => [
    <SearchBar key='search' source='value' fields={BRAND_SEARCH_FIELDS} label={translate('common.search')} alwaysOn />,
    <ReferenceArrayFilter
        key='retailChain'
        source='retailChain->id_in'
        reference='retail-chain'
        label={translate('resources.brand.filters.retailChain')}
        searchFields={['name']}
        perPage={1000}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='contractorCount'
        source='contractorCount_range'
        label={translate('resources.brand.filters.contractorCount')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
    <FromToFilterComponent
        key='collectionPointCount'
        source='collectionPointCount_range'
        label={translate('resources.brand.filters.collectionPointCount')}
        forceDesktopOnMobile={true}
        alwaysOn={isMobile}
    />,
];
